import { Validator } from './Validator'
import { parse } from 'url'
import { isNullOrUndefined } from 'util'

/**
 * Validator on empty value
 * If input value is a string then value will be trimmed before test
 * @param value input value
 * @returns 'empty' if value is invalid
 */
export const empty: Validator = (value: any) => {
    return !value ? 'empty' : (typeof value === 'string' ? (!(value.trim()) ? 'empty' : undefined) : undefined)
}
export const emptyObj: Validator = (value: any) => {
    return isNullOrUndefined(value) ? 'emptyObj' : undefined
}
const emailPattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,6}\.)?[a-z]{2,6}$/i
export const email: Validator = (value: string) => {
    return !value ? 'email' : (emailPattern.test(value) ? undefined : 'email')
}

const phonePattern = /^(((\+1)?(([0-9]{10})|(\([0-9]{3}\)[0-9]{3}(\-?)[0-9]{4})))|((\+1 )?((([0-9]{3}) ([0-9]{3}) ([0-9]{4}))|(\([0-9]{3}\) [0-9]{3}( |\-)[0-9]{4}))))$/i
export const phone: Validator = (value: any) => {
    return !value ? 'phone' : (phonePattern.test(value) ? undefined : 'phone')
}

export const name: Validator = (value: any) => {
    let result = empty(value)
    return result ? 'name' : undefined
}

const zipCodePattern = /^[0-9]{5}$/i
export const zipCode: Validator = (value: any) => {
    return !value ? 'zip' : (zipCodePattern.test(value) ? undefined : 'zip')
}

const passwordPattern = /(?=^.{8,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!@#$%,.^&*()]*$/
export const password: Validator = (value: any) => {
    return !value ? 'pass' : (passwordPattern.test(value) ? undefined : 'pass')
}

const licenseNumberPattern = /^[A-Za-z0-9]{1,19}$/
export const license: Validator = (value: any) => {
    return !value ? 'license' : (licenseNumberPattern.test(value) ? undefined : 'license')
}

export const minLength = (length: number) => {
    return (value: string) => {
        return !value || value.length < length ? 'min' : undefined
    }
}

const ssnPattern = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/
export const ssn: Validator = (value: any) => {
    return !value ? 'ssn' : (ssnPattern.test(value) ? undefined : 'ssn')
}

const einPattern = /^[0-9]{2}-[0-9]{7}$/
export const ein: Validator = (value: any) => {
    return !value ? 'ein' : (einPattern.test(value) ? undefined : 'ein')
}
const verificationCodePattern = /^[0-9]+$/
export const verificationCode: Validator = (value: any) => {
    return !value ? 'vc' : (verificationCodePattern.test(value) ? undefined : 'vc')
}
// const cardNumberPattern = /^[0-9]{16}$/i
// export const cardNumber: Validator = (value: any) => {
//     return !value ? 'card' : (cardNumberPattern.test(value) ? undefined : 'card')
// }
// export const cardExpirationDate: Validator = (value: any) => {
//     // tslint:disable-next-line:radix
//     return !value ? 'cardem' : (parseInt(value) > 0 && parseInt(value) < 13) ? undefined : 'cardem'
// }
// export const cardExpirationMonth: Validator = (value: any) => {
//     // tslint:disable-next-line:radix
//     return !value ? 'cardem' : (parseInt(value) > 0 && parseInt(value) < 13) ? undefined : 'cardem'
// }
// export const cardExpirationYear: Validator = (value: any) => {
//     // tslint:disable-next-line:radix
//     return !value ? 'cardey' : (parseInt(value) >= 18 && parseInt(value) <= 99) ? undefined : 'cardey'
// }
// const cardCVVPattern = /^[0-9]{3}$/i
// export const cardCVV: Validator = (value: any) => {
//     return !value ? 'cvv' : (cardCVVPattern.test(value) ? undefined : 'cvv')
// }



// WEBPACK FOOTER //
// ./src/utils/validation/Validators.ts